import 'babel-polyfill';
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'

import {scrollHandler, offset, resizeHandler, customFunctions, connectionCheck} from './mixins/index.js'
import moment from 'moment'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import Meta from 'vue-meta'
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */

// router.afterEach(function (to, from) {
//     if (from.name !== null) {
//         _paq.push(['setDocumentTitle', to.name])
//         _paq.push(['setCustomUrl', to.path])
//         _paq.push(['trackPageView']);
//     }
// })

let $ = require('jquery');
require('lottie-web')
window.jQuery = $;
require('./styles/globals.scss')
require('./styles/video.scss')

const assign = Object.assign || function assign(to) {
    for (let s = 1; s < arguments.length; s += 1) {
        const from = arguments[s];
        for (const key in from) {
            to[key] = from[key];
        }
    }
    return to;
};

moment.locale('de')
Vue.use(Vuex)
Vue.use(Meta)
Vue.use(Vue2TouchEvents)
Vue.mixin(scrollHandler)
Vue.mixin(offset)
Vue.mixin(resizeHandler)
Vue.mixin(customFunctions)
Vue.mixin(connectionCheck)

var vueSmoothScroll = require('vue-smoothscroll');
Vue.use(vueSmoothScroll);

let session = window.sessionStorage,
    storage = window.localStorage,
    log = console && console.log || function () {
    };
Vue.config.productionTip = false
Vue.config.debug = process.env.DEBUG_MODE

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js